import React, { FC } from 'react'
import { CardBlock } from './style'
import { getRoleFromPath, navigateTo } from 'utils/helper'
import { toolsTabs } from 'config'

interface IBlockEmptyStateProps {
  category: string
}

const BlockEmptyState: FC<IBlockEmptyStateProps> = ({ category }) => {
  const userRole = getRoleFromPath()
  const navigateToAllTools = () => {
    navigateTo(userRole, `tools/${toolsTabs[1].link}`)
  }
  return (
    <CardBlock className="w-full xs:max-w-[100%] sm:max-w-[354px] h-[300px] flex flex-col justify-center items-center border border-primary-outline rounded-[20px] bg-white pt-6">
      <span className="block text-lg text-primary-text leading-6 font-bold my-2">
        You have 0 {category} tools
      </span>
      <span
        className="text-[16px] font-semibold font-primary cursor-pointer text-primary"
        onClick={navigateToAllTools}
      >
        Go to All Tools
      </span>
    </CardBlock>
  )
}

export default BlockEmptyState
